import {applyDefaultState} from '../../utils/Apply/defaultState';
import { APPLY_EVENTS } from '../../constants/events';


const applyReducer = (state=applyDefaultState, actions) => {
  switch (actions.type) {
    case 'UPDATE_APPLY':
      state = Object.assign({}, state, actions.payload);
      break;
    case APPLY_EVENTS.TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS:
      state = Object.assign({}, state, actions.payload);
      break;
    case 'FORM_FIELD_CHANGE':
      state.applyForm = Object.assign({}, state.applyForm, actions.payload);
      break;
    case APPLY_EVENTS.WHATSAPP_NOTIFICATION:
      const payload = {whatsAppOptInFlag:actions.payload};
      state.applyForm = Object.assign({},state.applyForm,payload);
      break;
    case APPLY_EVENTS.TOGGLE_SKIP_APPLY_FLAG:
    case APPLY_EVENTS.TOGGLE_QUICK_APPLY_FLAG:
    case APPLY_EVENTS.SET_UTM_PARAMETERS:
      state = Object.assign({}, state, actions.payload);
      break;
  }
  return state;
};

export default applyReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/ApplyReducer/index.js